export const isDevelopment = () => {
  return process.env.NODE_ENV == 'development'
}

export const isDebug = (filter = '') => {
  if(!filter) return process.env.DEBUG ? true : false
  return process.env.DEBUG && process.env.DEBUG.indexOf(filter) >= 0 ? true : false
}
  
export const isLogger = () =>
  isDevelopment() || isDebug()

export const isDebug_Websockets = () => isDebug('websockets')
export const isDebug_Roles = () => isDebug('roles')